import React from 'react'
import { graphql, useFragment } from 'react-relay'
import { Trans } from '@lingui/react/macro'

import { Card } from '@newComponents/Card'
import { FormattedMarkdown } from '@newComponents/FormattedMarkdown/FormattedMarkdown'
import { Paragraph } from '@newComponents/Text'

import { EventScreenDescription_event$key } from './__generated__/EventScreenDescription_event.graphql'

export const EventScreenDescription = ({
  event,
}: {
  event: EventScreenDescription_event$key
}) => {
  const data = useFragment(
    graphql`
      fragment EventScreenDescription_event on Event {
        description

        owner {
          __typename
          ... on User {
            isMe
          }

          ... on Guild {
            myMembership {
              membershipLevel
            }
          }
        }
      }
    `,
    event
  )

  if (data.description) {
    return (
      <Card glass gap='$6'>
        <FormattedMarkdown>{data.description}</FormattedMarkdown>
      </Card>
    )
  }

  if (!data.owner) {
    return null
  }

  if (
    data.owner.__typename === 'Guild' &&
    ['ORGANIZER', 'EDITOR'].includes(
      data.owner.myMembership?.membershipLevel || ''
    )
  ) {
    return (
      <Card glass gap='$6'>
        <Paragraph color='$errorColor' fontWeight='$5'>
          <Trans>Missing description</Trans>
        </Paragraph>
      </Card>
    )
  }

  if (data.owner.__typename === 'User' && data.owner.isMe) {
    return (
      <Card glass gap='$6'>
        <Paragraph color='$errorColor' fontWeight='$5'>
          <Trans>Missing description</Trans>
        </Paragraph>
      </Card>
    )
  }

  return null
}
